import { SimulacaoPrecoItemContract } from "app/types/simulacao-preco/SimulacaoPrecoItemContract"
import React, { useEffect, useState } from "react"
const estilosFormulario = require('../../estilos/formulario.module.scss').default
import clsx from "clsx"
import { ItemSimulacao } from "./ItemSimulacao"
import { ComposicaoCustoSimulacaoPrecoItemContract } from "app/types/simulacao-preco/ComposicaoCustoSimulacaoPrecoItemContract"
import { ComposicaoSimulacaoPrecoItemContract } from "app/types/simulacao-preco/ComposicaoSimulacaoPrecoItemContract"
import { substituirItemEmArray } from "substituirItemEmArray"
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosTabelas = require('../../estilos/tabelas.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default
import { v4 as uuidv4 } from "uuid";
import * as R from 'ramda'
import { TipoPesquisaContract } from "app/types/simulacao-preco/TipoPesquisaContract"
import {parse,format} from 'date-fns'
import globalMU from "globalMU"
import { InputNumerico } from "../inputs/InputNumerico"
import { tratamentoErroPadrao } from "app/use-cases/tratamentoErroPadrao"
import { bool } from "yup"

type DadosSimulacao = {
    precoLista: number
    precoVendaInformado: number
    precoVendaBaseCustoReal?: number,
    precoCustoReal: number
    novaComposicao: ComposicaoSimulacaoPrecoItemContract[]
    markup: number
    precoCusto: number
    calculo?: string
    aplicarPrecoVendaInformado?: boolean
}

type SimuladorPrecoProps = {
    dadosSimulacao: SimulacaoPrecoItemContract
    tiposPesquisa: TipoPesquisaContract[]
    numeroCasasDecimaisPrecoVenda:number
    numeroCasasDecimaisPrecoCompra:number
    desativarBotaoAplicar: boolean
    permiteEditarMarkup: boolean // 453508
    carregandoDados: boolean
    somenteLeitura: boolean
    processando: boolean
    onAplicar: (dados: DadosSimulacao) => void
    onCalcular: (dados: DadosSimulacao) => void
    onCancelar: () => void
}

const SimuladorPreco = (props: SimuladorPrecoProps) => {
    const obterPrecoFormatado = (preco:number,numeroCasasDecimais) =>   globalMU.vazioOuNulo(preco) ? null :
                                                    globalMU.formatarValorNumerico(preco, numeroCasasDecimais, false)

    const atribuirUUIDParaItemSimulacao = (item: ComposicaoSimulacaoPrecoItemContract) : ComposicaoSimulacaoPrecoItemContract => {
        return {
            ...item,
            uuid: uuidv4()
        } as ComposicaoSimulacaoPrecoItemContract
    }
    /*
    const [precoLista, setPrecoLista] = useState<string>(obterPrecoFormatado(props.dadosSimulacao?.PrecoLista,props.numeroCasasDecimaisPrecoCompra))
    */
    const [precoLista, setPrecoLista] = useState<number>(props.dadosSimulacao?.PrecoLista ?? 0)
    const [precoCusto, setPrecoCusto] = useState<number>(props.dadosSimulacao?.PrecoCusto ?? 0)
    const [markup,setMarkup] = useState<number>(null)
    
    const [dadosSimulacao, setDadosSimulacao] =  useState<SimulacaoPrecoItemContract>(props.dadosSimulacao == null ? null : {
        ...props.dadosSimulacao,
        Composicao: props.dadosSimulacao?.Composicao?.map(atribuirUUIDParaItemSimulacao)
    })

    const [existemModificacoesNaoSalvas,setExistemModificacoesNaoSalvas] = useState(false)
    const [precoVendaInformado,setPrecoVendaInformado] = useState<number>(props.dadosSimulacao?.PrecoVendaInformado)

    

    const tipoItemJaAtribuidoAOutroItemDaSimulacao = (uuidReferencia:string,oidTipoPesquisa:number) : boolean => {
        const outrosItens = dadosSimulacao.Composicao?.filter(item => !item.Excluido)
            .filter(item => item.uuid != uuidReferencia)

        const algumItemPossuiEsteTipo = outrosItens.some(item => item.OidTipoPesquisa == oidTipoPesquisa)

        return algumItemPossuiEsteTipo
    }

    const filtrarItemComposicao = (item:ComposicaoSimulacaoPrecoItemContract) : boolean => {
        return !item.Excluido
    }

    const obterComposicaoSemOItem = (uuidItem:string) : ComposicaoSimulacaoPrecoItemContract[] => {
        const item = dadosSimulacao.Composicao?.find(item => item.uuid == uuidItem)

        return  item.Index == 0 ? dadosSimulacao.Composicao?.filter(itemComposicao => itemComposicao.uuid != uuidItem) :
                dadosSimulacao.Composicao?.map(itemComposicao => itemComposicao.uuid == uuidItem ? {...itemComposicao,Excluido: true} : itemComposicao)
    }

    const obterProximoIndiceItemComposicao = () => {
        return dadosSimulacao.Composicao?.map(itemComposicao => itemComposicao.Index)
            .reduce((max,cur) => cur > max ? cur : max,0) + 1
    }

    useEffect(() => {
        setDadosSimulacao(props.dadosSimulacao == null ? null : {
            ...props.dadosSimulacao,
            Composicao: props.dadosSimulacao?.Composicao?.map(atribuirUUIDParaItemSimulacao)
        })
        setMarkup(props.dadosSimulacao?.Markup ?? 0)
        setPrecoCusto(props.dadosSimulacao?.PrecoCusto ?? 0)
        setPrecoLista(props.dadosSimulacao?.PrecoLista ?? 0)
        setPrecoVendaInformado(props.dadosSimulacao?.PrecoVendaInformado ?? 0)

        //atualizarMarkup(props.dadosSimulacao?.PrecoVendaInformado)
        setExistemModificacoesNaoSalvas(true)
    },[props.dadosSimulacao,props.numeroCasasDecimaisPrecoCompra,props.numeroCasasDecimaisPrecoVenda,props.permiteEditarMarkup])

    useEffect(() => {
        if (props.dadosSimulacao != null && !props.processando && props.permiteEditarMarkup)
        {
            props.onCalcular({
                precoLista: precoLista,
                precoVendaInformado: precoVendaInformado,
                precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                precoCustoReal: dadosSimulacao.PrecoCustoReal,
                novaComposicao: dadosSimulacao.Composicao,
                calculo: "PrecoVendaInformado",
                markup: markup,
                precoCusto: precoCusto,

            })
        }

    },[precoVendaInformado])

    useEffect(() => {
        if (props.dadosSimulacao != null && !props.processando)
        {
            props.onCalcular({
                precoLista: precoLista,
                precoVendaInformado: precoVendaInformado,
                precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                precoCustoReal: dadosSimulacao.PrecoCustoReal,
                novaComposicao: dadosSimulacao.Composicao,
                calculo:"Markup",
                markup: markup,
                precoCusto: precoCusto,

            })
        }
    },[markup])

    useEffect(() => {
        if (props.dadosSimulacao != null && !props.processando)
        {
            props.onCalcular({
                precoLista: precoLista,
                precoVendaInformado: precoVendaInformado,
                precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                precoCustoReal: dadosSimulacao.PrecoCustoReal,
                novaComposicao: dadosSimulacao.Composicao,
                calculo:"PrecoCusto",
                markup: markup,
                precoCusto: precoCusto,

            })
        }
    },[precoCusto])

    useEffect(() => {
        if (props.dadosSimulacao != null && !props.processando)
        {
            props.onCalcular({
                precoLista: precoLista,
                precoVendaInformado: precoVendaInformado,
                precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                precoCustoReal: dadosSimulacao.PrecoCustoReal,
                novaComposicao: dadosSimulacao.Composicao,
                calculo:"PrecoLista",
                markup: markup,
                precoCusto: precoCusto,

            })
        }
    },[precoLista])

    return props.carregandoDados ? <>Carregando, aguarde... </> : 
            dadosSimulacao == null ? <>Sem dados para executar simulação</> : <>

        <div className={clsx(estilosFormulario.formulario)}
            id="SimuladorPreco_dadosSimulacao"
        >
            <label >Produto</label>
            <span 
                style={{maxWidth: "25rem", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}
                title={dadosSimulacao.ProdutoDescricao}
            >
            {dadosSimulacao.ProdutoDescricao}
            </span>

            {dadosSimulacao.Fornecedor != null && dadosSimulacao.Fornecedor != '' && <>
            <label >Fornecedor</label>
            <span
                style={{maxWidth: "25rem", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden"}}
                title={dadosSimulacao.Fornecedor}
            >{dadosSimulacao.Fornecedor}</span>
            </>}

            {dadosSimulacao.FormaDePagamento != null && dadosSimulacao.FormaDePagamento != '' && <>
            <label
                title="Forma de pagar da última pesquisa de preço"
            >Forma de Pagar</label>
            <span>{dadosSimulacao.FormaDePagamento}</span>
            </>}

            {dadosSimulacao.Unidade != null && dadosSimulacao.Unidade != '' && <>
            <label>Unidade</label>
            <span>{dadosSimulacao.Unidade}</span>
            </>}

            <label>Validade</label>
            <span>{globalMU.vazioOuNulo(dadosSimulacao.Validade) ? '' : format(new Date(dadosSimulacao.Validade),"dd/MM/yyyy")}</span>

            <label>Quantidade Mín. de Compra</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.QuantidadeMinimaCompra,3)}</span>

            <label
                title="Veja parâmetro: Número de casas decimais na compra"
            >Preço da Lista</label>
            <InputNumerico
                id="SimuladorPreco_precoListaInput"
                valor={precoLista}
                style={{width: "10rem"}}
                title="Veja parâmetro: Número de casas decimais na compra"
                numeroCasasDecimais={props.numeroCasasDecimaisPrecoCompra}
                disabled={true} //{props.somenteLeitura || props.processando}
                /*
                Renato Telles — Hoje às 11:23
O preço de custo é o preço de lista + ST + cálculo composição
por enquanto não se preocupa com o preço de lista
*/
                onValorModificado={valor => {
                    if (valor <= 0) {
                        tratamentoErroPadrao("O preço da lista inválido.")
                        return
                    }
                    setPrecoLista(valor) 
                    setExistemModificacoesNaoSalvas(true)}
                }
            />

            <label
                title="Veja parâmetro: Número de casas decimais no Preço de Venda"
            >Substituição Tributária</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.ValorSubstituicaoTributaria,props.numeroCasasDecimaisPrecoVenda)}</span>

            <label
                title="Veja parâmetro: Número de casas decimais no Preço de Venda"
            >Substituição Tributária Antecipada</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.ValorSubstituicaoTributariaAntecipada, props.numeroCasasDecimaisPrecoVenda)}</span>

            <label
                title="Veja parâmetro: Número de casas decimais na compra"
            >Preço Custo</label>
            {/* <span>{globalMU.formatarValorNumerico(dadosSimulacao.PrecoCusto,props.numeroCasasDecimaisPrecoCompra)}</span> */}
            <InputNumerico
                id="SimuladorPreco_precoCustoInput"
                valor={dadosSimulacao.PrecoCusto} 
                style={{width: "10rem"}}
                title="Veja parâmetro: Número de casas decimais na compra"
                numeroCasasDecimais={props.numeroCasasDecimaisPrecoCompra}
                disabled={props.somenteLeitura || props.processando}
                onValorModificado={valor => { // 457575
                    if (valor <= 0) {
                        tratamentoErroPadrao("O preço de custo inválido.")
                        return
                    }
                    setPrecoCusto(valor) 
                    setExistemModificacoesNaoSalvas(true)}
                }
            />

            <label htmlFor="SimuladorPreco_markupInput"
                title="Veja parâmetro: Visualiza Mark-up do produto no orçamento?"
            >Markup</label>
            {!props.permiteEditarMarkup  && // 453508
            <span>
                {globalMU.formatarValorNumerico(markup,3,false)}
            </span>
            }
             {props.permiteEditarMarkup  && // 453508
            <InputNumerico // 453508
                id="SimuladorPreco_markupInput"
                style={{width: "10rem"}}
                numeroCasasDecimais={2} // {props.numeroCasasDecimaisPrecoVenda}
                valor={markup ?? 0}
                onValorModificado={valor => {
                    setMarkup(valor) 
                    setExistemModificacoesNaoSalvas(true)}
                }
            />
            }


            <label
                title="Veja parâmetro: Número de casas decimais no Preço de Venda"
            >Preço de Venda Informado</label>
            <InputNumerico
                id="SimuladorPreco_precoVendaInformadoInput"
                title="Veja parâmetro: Número de casas decimais no Preço de Venda"
                //className={clsx("_w-40",estilosInputs.campoEntrada)}
                valor={precoVendaInformado}
                //style={estilosInputs.campoEntrada}
                style={{width: "10rem"}}
                disabled={props.somenteLeitura || props.processando}
                numeroCasasDecimais={props.numeroCasasDecimaisPrecoVenda}
                onValorModificado={valor => {
                    if (valor < 0) {
                        tratamentoErroPadrao("O preço de venda informado inválido.")
                        return
                    }
                    setPrecoVendaInformado(valor) 
                    setExistemModificacoesNaoSalvas(true)}
                } 
                />
            {/* <label
                title="Veja parâmetro: Número de casas decimais no Preço de Venda"
            >Preço Venda</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.PrecoVenda,props.numeroCasasDecimaisPrecoVenda)}</span> */}
            

            <label>Prazo de Entrega</label>
            <span>{dadosSimulacao.PrazoEntrega}</span>

            {dadosSimulacao.DescricaoInsumo != null && dadosSimulacao.DescricaoInsumo != '' && <>
            <label>Descrição do Insumo</label> 
            <span>{dadosSimulacao.DescricaoInsumo}</span>
            </>}
            
            {dadosSimulacao.CodigoInsumo != null && dadosSimulacao.CodigoInsumo != '' && <>
            <label>Código do Insumo</label>
            <span>{dadosSimulacao.CodigoInsumo}</span>
            </>}

            <label
                title="Veja parâmetro: Número de casas decimais na compra"
            >Preço NF</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.PrecoNotaFiscal,props.numeroCasasDecimaisPrecoCompra)}</span>

           

            <label>Margem Zero</label>
            <span>{globalMU.formatarValorNumerico(dadosSimulacao.MargemZero,props.numeroCasasDecimaisPrecoCompra)}</span>

            {/* *****************remover**** foi so para teste*** inicio */}
            {/* <label style={{color: "red"}}>precoVendaInformado</label>
            <span style={{color: "red"}}>{props.dadosSimulacao?.PrecoVendaInformado}</span>

            <label style={{color: "red"}}>precoVendaBaseCustoReal</label>
            <span  style={{color: "red"}}>{props.dadosSimulacao?.PrecoVendaBaseCustoReal}</span>

            <label style={{color: "red"}}>precoCustoReal</label>
            <span  style={{color: "red"}}>{props.dadosSimulacao?.PrecoCustoReal}</span> */}

            {/* *****************remover**** foi so para teste*** FIM */}
        </div>

        {!props.somenteLeitura && 
        <button className={clsx(estilosBotoes.botaoPrimario,"_mt-2","_mb-2")} 
        title="Calcula o markup a partir dos dados informados"
        disabled={!existemModificacoesNaoSalvas  || props.processando}
        onClick={() => {
            props.onCalcular({
                precoLista: precoLista,
                precoVendaInformado: precoVendaInformado,
                precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                precoCustoReal: dadosSimulacao.PrecoCustoReal,
                novaComposicao: dadosSimulacao.Composicao,
                calculo: "PrecoVendaInformado", // 458911
                markup: null,
                precoCusto: precoCusto,
            })
        
        }}
            id="SimuladorPreco_botaoCalcular"
        >
            Calcular
        </button>
    }
    {!props.somenteLeitura && 
        <button className={clsx(estilosBotoes.botaoPrimario,"_mt-2","_mb-2", "_ml-2")} 
            id="SimuladorPreco_botaoAplicar"
            title="Aplica as alterações feitas na simulação de preço no item de pedido"
            //disabled={props.desativarBotaoAplicar || props.processando}
            disabled={props.processando}
            onClick={() => {
                props.onAplicar({
                    /*
                    precoLista: Number(globalMU.corrigirPontosEVirgulasValorDecimal(precoLista)),
                    precoVendaInformado: Number(globalMU.corrigirPontosEVirgulasValorDecimal(precoVendaInformado)),
                    */
                    precoLista: precoLista,
                    precoVendaInformado: precoVendaInformado,
                    precoVendaBaseCustoReal: dadosSimulacao.PrecoVendaBaseCustoReal,
                    precoCustoReal: dadosSimulacao.PrecoCustoReal,
                    novaComposicao: dadosSimulacao.Composicao,
                    calculo: null,
                    markup: markup,
                    precoCusto: precoCusto,
                    aplicarPrecoVendaInformado: true,
                })

                setExistemModificacoesNaoSalvas(false)
        }}>
            Aplicar Preço Venda
        </button>
        
        }

        <button className={clsx(estilosBotoes.botaoPrimario,"_mt-2","_mb-2", "_ml-2")} 
            id="SimuladorPreco_botaoSair"
            title="Sai da tela de simulação de preço sem salvar as alterações"
            disabled={props.processando}
            onClick={() => {
                props.onCancelar()
        }}>
            Sair
        </button>
        
        <table className={estilosTabelas.tabela}
            id="SimuladorPreco_tabelaComposicao"
            >
            <thead>
                <tr id="SimuladorPreco_LinhaCabecalhoComposicao"
                >
                    <th>
                        Item
                    </th>
                    <th>
                        Cálculo
                    </th>
                    <th>
                        Valor
                    </th>
                    <th>

                    </th>

                </tr>
            </thead>
            <tbody
                id ="SimuladorPreco_tabelaComposicao"
                >
                {dadosSimulacao.Composicao?.filter(filtrarItemComposicao).map(itemSimulacao => <ItemSimulacao
                    key={itemSimulacao.uuid}
                    itemSimulacao={itemSimulacao}
                    somenteLeitura={props.somenteLeitura}
                    processando={props.processando}
                    tiposPesquisa={props.tiposPesquisa.filter(tipoPesquisa => !tipoItemJaAtribuidoAOutroItemDaSimulacao(itemSimulacao.uuid,tipoPesquisa.Oid))}
                    onDadosAlterados={(oidTipoPesquisa, valor,oidCalculo) => {
                  /*
                        const itemSimulacaoExistente = dadosSimulacao.Composicao?.find(item => item.OidTipoPesquisa == oidTipoPesquisa) || 
                            dadosSimulacao.Composicao?.find(item => item.OidTipoPesquisa == null)
*/
                        const itemSimulacaoExistente = dadosSimulacao.Composicao?.find(item => !item.Excluido && item.OidTipoPesquisa == oidTipoPesquisa) || 
                            dadosSimulacao.Composicao?.find(item => item.OidTipoPesquisa == null)
                        const novoItemSimulacao = {
                            ...itemSimulacaoExistente,
                            Excluido: false, 
                            OidCalculo: oidCalculo,
                            Valor: valor,
                            OidTipoPesquisa: oidTipoPesquisa,
                            Nome: props.tiposPesquisa.find(t => t.Oid == oidTipoPesquisa)?.Nome,
                            Index: (itemSimulacaoExistente?.Index || 0) != 0 ? itemSimulacaoExistente.Index : obterProximoIndiceItemComposicao() 
                        } as ComposicaoSimulacaoPrecoItemContract
                        
                        const novaComposicao = substituirItemEmArray(
                            dadosSimulacao.Composicao,
                            (item: ComposicaoSimulacaoPrecoItemContract) => item.OidTipoPesquisa == null || ( !item.Excluido && item.OidTipoPesquisa == novoItemSimulacao.OidTipoPesquisa ), 
                            novoItemSimulacao)
                            /*
                        setDadosSimulacao({
                            ...dadosSimulacao,
                            Composicao: substituirItemEmArray(
                                dadosSimulacao.Composicao,
                                (item: ComposicaoSimulacaoPrecoItemContract) => item.OidTipoPesquisa == null || item.OidTipoPesquisa == novoItemSimulacao.OidTipoPesquisa, 
                                novoItemSimulacao)
                        })
                                */
                        setDadosSimulacao({
                            ...dadosSimulacao,
                            Composicao: novaComposicao
                        })
                        setExistemModificacoesNaoSalvas(true)
                    }} 
                    onItemRemovido={() => {
                        setDadosSimulacao({
                            ...dadosSimulacao,
                            Composicao: obterComposicaoSemOItem(itemSimulacao.uuid)
                        })

                        setExistemModificacoesNaoSalvas(true)
                    }}/>)}
            </tbody>
        </table> 
        
        <div> {!props.somenteLeitura &&
        <button 
                className={clsx(estilosBotoes.botaoPrimario,"_mb-2","_mt-2")} 
                title="Adicionar item de composição"
                id="SimuladorPreco_botaoAdicionarItem"
                disabled={props.processando}
                onClick={() => {
                    setDadosSimulacao({
                        ...dadosSimulacao,
                        Composicao: R.append({
                            Excluido: false,
                            Index: obterProximoIndiceItemComposicao(),
                            Nome: null,
                            OidCalculo: null,
                            Valor: null,
                            Oid: null,
                            OidTipoPesquisa: null,
                            uuid: uuidv4()
                        } as ComposicaoSimulacaoPrecoItemContract,dadosSimulacao.Composicao)
                    })

                    setExistemModificacoesNaoSalvas(true)
                }}>
                +
        </button>       
        }

        </div>
        <section style={{ marginBottom: "10px" }} />
    </>
}

export {
    SimuladorPreco,
    SimuladorPrecoProps,
    DadosSimulacao
}


